import { render, staticRenderFns } from "./SetLogout.vue?vue&type=template&id=4071b09c&"
import script from "./SetLogout.vue?vue&type=script&lang=js&"
export * from "./SetLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports